import { render, staticRenderFns } from "./ServiceTopicCard.vue?vue&type=template&id=773dcfc9"
import script from "./ServiceTopicCard.vue?vue&type=script&lang=js"
export * from "./ServiceTopicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports